export default __webpack_public_path__ + "static/media/Tiger's Boots of Grinning Skulls.60378291.jpg";